<template>
  <footer class="footer">
    <div class="container">
      <!-- <h3 class="logo">唐山职业教育网络教学资源库</h3> -->
      <div class="divider-box">
        <a @click="navClick(item, index)" v-for="(item, index) in navList.slice(0, 8)" :key="index">{{ item.title }} <span
            class="line" v-if="index <= 6">|</span> </a>
      </div>
      <div class="icp" v-if="footerList">
        <div>
          <span v-for="(item, index) in footerList.footer1.split('|')" :key="index">
            <a target="_blank" :href="item.split('$')[1]"> {{ item.split('$')[0] }}</a></span>
        </div>
        <div class="icp2">
          <span v-for="(item, index) in footerList.footer2.split('|')" :key="index">
            <a target="_blank" :href="item.split('$')[1]">{{ item.split('$')[0] }}</a>
          </span>
        </div>
        <div class="icp2">
          <a target="_blank" :href="footerList.beian.split('$')[1]">  {{ footerList.beian.split('$')[0] }}</a></div>
      </div>
    </div>

  </footer>
</template>
<script>
import mixin from '@/utils/mixin';
import { getWebFooter } from '@/utils/api'
import { mapGetters } from 'vuex';
export default {
  mixins: [mixin],
  data() {
    return {
      footerList: null
    }

  },

  computed: mapGetters(['schoolId', 'navList']),
  watch: {
    schoolId: function () {
      this.initData()
    }
  },
  created() {
    this.initData()

  },
  methods: {
    initData() {
      getWebFooter({
        organizeId: this.schoolId
      }).then(res => {
        this.footerList = res.data
        this.$store.commit('set_service', res.data.telePhone)
      })
    }
  }

}
</script>
<style scoped lang="scss">
.footer {
  // height: 168px;
  background: #434343;
  user-select: none;
}

.container {
  width: 1280px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  padding: 20px 0;
  margin-bottom: 0;
  background: #434343;
}

.divider-box {
  margin: 10px 0;

  a {
    cursor: pointer;

    .line {
      padding: 0 8px;
    }
  }
}

.icp {
  margin-bottom: 10px;

  span {
    margin-right: 15px;
    a{
      color: #fff;
    }
  }
}

.icp2 {
  margin-top: 10px;
  a{
      color: #fff;
    }
}

.source {
  text-align: center;
}

.source span {
  margin: 0 15px;
}

.footer-bottom {
  width: 100%;
  background: #3390f8;
  height: 48px;
  overflow: hidden;
  color: #fff;
  line-height: 48px;
  font-size: 14px;
}
</style>